<template>
  <div :ref="ename" class="ec"></div>
</template>
    
    <script>
import { fontSize } from "@/js/utils";
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    ename: {
      type: String,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    onclick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myChart: "",
      list: [],
      option: {
        grid: {
          top: '5%',
          bottom: 0,
          right: '10%',
          left: '5%',
          containLabel: true,
        },
        xAxis: {
          show: false,
        },
        yAxis: [
          {
            triggerEvent: true,
            show: true,
            inverse: true,
            data: [],
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
              interval: 0,
              color: "#fff",
              align: "left",
              margin: fontSize(2),
              fontSize: fontSize(0.12),
              formatter: function (value, index) {
                return "{title|" + value + "}";
              },
              rich: {
                title: {
                  width: fontSize(1.65),
                },
              },
            },
          },
          {
            triggerEvent: true,
            show: true,
            inverse: true,
            data: [],
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              color: "#fff",
              lineHeight: fontSize(0.2),
              fontSize: fontSize(0.12),
              formatter: (value, index) => {
                return value+"台";
              },
            },
          },
        ],
        series: [
          {
            name: "XXX",
            type: "pictorialBar",
            barBorderRadius: fontSize(0.3),
            barWidth: fontSize(0.05),
            itemStyle: {
              normal: {
                color: "#19D6FF",
                barBorderRadius: fontSize(0.1),
              },
              // color: '#A71A2B',
              barBorderRadius: fontSize(0.1),
            },
            data: [],
            label: {
              normal: {
                show: false,
              },
            },
          },
          {
            name: "条",
            type: "bar",
            showBackground: true,
            barBorderRadius: fontSize(0.3),
            yAxisIndex: 0,
            data: [],
            barWidth: fontSize(0.05),
            itemStyle: {
              normal: {
                color: "#19D6FF",
                barBorderRadius: fontSize(0.1),
              },
              // color: '#A71A2B',
              barBorderRadius: fontSize(0.1),
            },
            label: {
              normal: {
                color: "#fff",
                show: true,
                position: [0, -fontSize(0.16)],
                textStyle: {
                  fontSize: fontSize(0.12),
                },
                formatter: function (a, b) {
                  return a.name;
                },
              },
            },
          },
        ],
      },
    };
  },
  computed: {
    full() {
      return this.$store.state.menuShow;
    },
  },
  watch: {
    full(newval) {
      this.myChart.resize();
    },
    data: {
      handler(newVal) {
        if (newVal && this.myChart != "") {
          this.list = newVal;
          this.updateOption();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getEchartData();
    window.addEventListener("resize", this.myChart.resize);
  },
  beforeDestroy() {
    // 移除窗口改变监听
    this.onclick && this.myChart.off("click", this.getClickInfo);
    window.removeEventListener("resize", this.myChart.resize);
  },
  methods: {
    getClickInfo(e) {
      this.$emit("click", e);
    },
    updateOption() {
      this.handlerData();
      this.myChart.setOption(this.option);
    },
    handlerData() {
       console.log(this.data);
      this.option.yAxis[0].data = this.data.xData || [];
      this.option.yAxis[1].data = this.data.yData || [];
      let arr = [];
     this.data.xData && this.data.xData.forEach((item) => {
        arr.push({
          value: item,
          symbolPosition: "end",
        });
      });
      this.option.series[0].data = arr;
      this.option.series[1].data = this.data.yData || [];
    },
    getEchartData() {
      this.handlerData();
      const chart = this.$refs[this.ename];
      if (chart) {
        this.myChart = this.$echarts.init(chart);
        this.myChart.setOption(this.option);
        this.onclick && this.myChart.on("click", this.getClickInfo);
      }
    },
  },
};
</script>
    
    <style lang="less" scoped>
.ec {
  width: 100%;
  height: 100%;
}
</style>